import { IconPack } from "Explore/Config/Icons";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";

export const _nav = [
  {
    label: "Faculty",
    key: "faculty",
    to: "/faculties",
    svg: IconPack.faculty_outline_black,
    svg_fill: IconPack.faculty_filled,
    svg_white: IconPack.faculty_outline_white,
  },
  {
    label: "Institution",
    key: "institution",
    to: "/institutions",
    svg: IconPack.institution_outline_black,
    svg_fill: IconPack.institution_filled,
    svg_white: IconPack.institution_outline_white,
  },
  {
    label: "Unit",
    key: "unit",
    to: "/units",
    svg: IconPack.unit_black,
    svg_white: IconPack.unit_white,
    svg_fill: IconPack.unit_fill,
  },
  {
    label: "Venue",
    key: "venue",
    to: "/venues",
    svg: IconPack.venue_outline_black,
    svg_fill: IconPack.venue_filled,
    svg_white: IconPack.venue_outline_white,
  },
  // {
  //   label: "Benchmark",
  //   key: "benchmarking",
  //   to: "/keyword-benchmarking",
  //   svg: <LeaderboardOutlinedIcon style={{ fontSize: 18 }} />,
  //   svg_fill: <LeaderboardOutlinedIcon style={{ fontSize: 18 }} />,
  //   svg_white: <LeaderboardOutlinedIcon style={{ fontSize: 18, color: "#fff" }} />,
  // },
  {
    label: "Benchmark",
    key: "benchmarking",
    to: "/analysis",
    svg: <LeaderboardOutlinedIcon style={{ fontSize: 18 }} />,
    svg_fill: <LeaderboardOutlinedIcon style={{ fontSize: 18 }} />,
    svg_white: <LeaderboardOutlinedIcon style={{ fontSize: 18, color: "#fff" }} />,
  },
  // {
  //   label: "Concept",
  //   key: "concept",
  //   to: "/concept",
  //   svg: IconPack.concept_outline_black,
  //   svg_fill: IconPack.concept_filled,
  //   svg_white: IconPack.concept_outline_white,
  // },
];
